export class GeneralConstants {
    static COMPONENT_NAME = {
      PERSON_SEARCH_FILTER: "person-search-filter",
      REPORT_PROFILES: "report-profiles",
      SC_MODAL: "sc-modal"
    }

    static REDIRECT_SOURCES = {
      TALENT_INSIGHTS: "talent-insights",
      COMPANY_INSIGHTS: "company-insights",
      JOB_DESCRIPTION: "job-description",
      AI_SOURCING: "ai-sourcing",
      NL_SEARCH: "nl-search"
    }

    static TYPE = {
      SIMILAR_CANDIDATE: "similar-candidates"
    }

    static YOE_TYPE = {
        TOTAL: "Total", AVG : "Average", CURRENT : "Current"
    };

    // LS - Local storage
    static LS_KEYS = {
        TALENT_FILTERS : "talentfiltersV2",
        UNIQUE_HASH : "uniqueHash",
        JOB_DESCRIPTION: "jobDescription",
        COMPANY_FILTERS : "companyfiltersV2",
        UNIQUE_HASH_COMPANY: "uniqueHash"
    }

    static FILTER_NAMES = {
        OVERALL_MATCH : "overall_match",
        JOB_TITLE : "job_title",
        LOCATION: "location",
        SKILLS: "skills",
        COMPANY: "company",
        COMPANY_SIZE: "company_size",
        INDUSTRIES: "industries",
        FUNCTIONS: "functions",
        SENIORITY: "seniority",
        YOE: "years_of_experience",
        YOE_CURRENT_COMPANY: "years_of_experience_current_company",
        GENDER: "gender",
        EDUCATION: "education",
        SCHOOL: "school",
        FIELD_OF_STUDY: "field_of_study",
        LIKELY_TO_MOVE_IN: "likely_to_move_in",
        KEYWORD: "keyword",
        CHANGED_JOB: "changedjob",
        PAST_JOB_TITLE: "pastjobtitle",
        KEYWORD_INPUT: "keyword_input",
        EDUCATION_LOCATION: "school_location",
        DISTANCE: "distance",
        HIGHLIGHTS: "highlights",
        POSITION_HIERARCHY: "position_hierarchy",
        GRADUATION_YEAR: "graduationyear",
        FULL_NAME: 'fullname'
    };

    static TALENT_INSIGHTS_APPLICABLE_FILTERS = new Set([
      GeneralConstants.FILTER_NAMES.JOB_TITLE, GeneralConstants.FILTER_NAMES.LOCATION,
      GeneralConstants.FILTER_NAMES.SKILLS, GeneralConstants.FILTER_NAMES.COMPANY,
      GeneralConstants.FILTER_NAMES.COMPANY_SIZE, GeneralConstants.FILTER_NAMES.INDUSTRIES,
      GeneralConstants.FILTER_NAMES.FUNCTIONS, GeneralConstants.FILTER_NAMES.YOE,
      GeneralConstants.FILTER_NAMES.YOE_CURRENT_COMPANY,
      GeneralConstants.FILTER_NAMES.SCHOOL, GeneralConstants.FILTER_NAMES.EDUCATION,
      GeneralConstants.FILTER_NAMES.GENDER,
      GeneralConstants.FILTER_NAMES.SENIORITY, GeneralConstants.FILTER_NAMES.FIELD_OF_STUDY,
      GeneralConstants.FILTER_NAMES.PAST_JOB_TITLE,
      GeneralConstants.FILTER_NAMES.KEYWORD_INPUT,
      GeneralConstants.FILTER_NAMES.GRADUATION_YEAR
    ]);

    static PERSON_SEARCH_APPLICABLE_FILTERS = new Set([
      GeneralConstants.FILTER_NAMES.JOB_TITLE, GeneralConstants.FILTER_NAMES.LOCATION,
      GeneralConstants.FILTER_NAMES.SKILLS, GeneralConstants.FILTER_NAMES.COMPANY,
      GeneralConstants.FILTER_NAMES.COMPANY_SIZE, GeneralConstants.FILTER_NAMES.INDUSTRIES,
      GeneralConstants.FILTER_NAMES.FUNCTIONS, GeneralConstants.FILTER_NAMES.YOE,
      GeneralConstants.FILTER_NAMES.YOE_CURRENT_COMPANY, GeneralConstants.FILTER_NAMES.LIKELY_TO_MOVE_IN,
      GeneralConstants.FILTER_NAMES.SCHOOL, GeneralConstants.FILTER_NAMES.EDUCATION,
      GeneralConstants.FILTER_NAMES.GENDER,
      GeneralConstants.FILTER_NAMES.SENIORITY, GeneralConstants.FILTER_NAMES.FIELD_OF_STUDY,
      GeneralConstants.FILTER_NAMES.CHANGED_JOB, GeneralConstants.FILTER_NAMES.PAST_JOB_TITLE,
      GeneralConstants.FILTER_NAMES.EDUCATION_LOCATION,
      GeneralConstants.FILTER_NAMES.KEYWORD_INPUT, GeneralConstants.FILTER_NAMES.DISTANCE, GeneralConstants.FILTER_NAMES.HIGHLIGHTS,
      GeneralConstants.FILTER_NAMES.POSITION_HIERARCHY,
      GeneralConstants.FILTER_NAMES.GRADUATION_YEAR,
      GeneralConstants.FILTER_NAMES.FULL_NAME
    ]);

    static HOVER_FILTER_NAME_MAP = {
      companySelectedList: "Company",
      companysize: 'Company Size',
      industrySelectedList: "Industry",
      functionSelectedList: "Function",
      seniority: "Seniority",
      gender: "Gender",
      educationSelectedList: "Education",
      schoolSelectedList: "School",
      fieldOfStudySelectedList: "Field Of Study",
      keywordSelectedList: "Keyword",
      yearsofexperienceFrom: "Years Of Experience",
      currentfromyearsofexperience: "Current Years Of Experience",
      pastJobTitleSelectedList: "Past Job Title",
      tograduationyear: "Graduation year"
    }

    static HOVER_MANDATORY_FILTER_NAME_MAP = {
      mandatoryjobtitles: "Job Title",
      mandatorylocations: "Location",
      mandatoryskills: "Skill",
      mandatorycompanies: "Company",
      mandatoryindustries: "Industry",
      mandatoryfunctions: "Function",
      mandatoryschools: "School",
      mandatoryeducationaldegrees: "Education",
      mandatoryseniority: "Seniority",
      mandatoryeducationalmajors: "Field Of Study"
    };

    static JD_FILTER_KEY_NAME_MAP = {
      job_titles: "Job Titles",
      mandatory_job_titles: "Mandatory Job Titles",
      skills: "Skills",
      mandatory_skills: "Mandatory Skills",
      schools: "Schools",
      mandatory_schools: "Mandatory Schools",
      locations: "Locations",
      mandatory_locations: "Mandatory Locations",
      company_sizes: "Company Sizes",
      mandatory_company_sizes: "Mandatory Company Sizes",
      companies: "Companies",
      mandatory_companies: "Mandatory Companies",
      industries: "Industries",
      mandatory_industries: "Mandatory Industries",
      degrees: "Degrees",
      mandatory_degrees: "Mandatory Degrees",
      education_majors: "Educational Majors",
      mandatory_education_majors: "Mandatory Educational Majors",
      fromYrsOfExperience: "From years of experience",
      toYrsOfExperience: "To years of experience",
    }
    static COMPANY_INSIGHTS_APPLICABLE_FILTERS = new Set([
      GeneralConstants.FILTER_NAMES.JOB_TITLE, GeneralConstants.FILTER_NAMES.LOCATION,
      GeneralConstants.FILTER_NAMES.SKILLS, GeneralConstants.FILTER_NAMES.FUNCTIONS,
      GeneralConstants.FILTER_NAMES.GENDER, GeneralConstants.FILTER_NAMES.SCHOOL,
      GeneralConstants.FILTER_NAMES.EDUCATION, GeneralConstants.FILTER_NAMES.FIELD_OF_STUDY,
      GeneralConstants.FILTER_NAMES.SENIORITY,
      GeneralConstants.FILTER_NAMES.KEYWORD_INPUT
    ]);

    static COMPANY_INSIGHTS_COMPARE_APPLICABLE_FILTERS = new Set([
      GeneralConstants.FILTER_NAMES.JOB_TITLE, GeneralConstants.FILTER_NAMES.LOCATION,
      GeneralConstants.FILTER_NAMES.SKILLS, GeneralConstants.FILTER_NAMES.FUNCTIONS,
      GeneralConstants.FILTER_NAMES.GENDER, GeneralConstants.FILTER_NAMES.SCHOOL,
      GeneralConstants.FILTER_NAMES.EDUCATION, GeneralConstants.FILTER_NAMES.FIELD_OF_STUDY,
      GeneralConstants.FILTER_NAMES.SENIORITY
    ]);

    static HOVER_MANDATORY_COMPANYFILTER_NAME_MAP = {
      mandatoryjobtitles: "Job Title",
      mandatorylocations: "Location",
      mandatoryskills: "Skill",
      mandatorycompanies: "Company",
      mandatoryindustries: "Industry",
      mandatoryfunctions: "Function",
      mandatoryschools: "School",
      mandatoryeducationaldegrees: "Education",
      mandatoryseniority: "Seniority",
      mandatoryeducationalmajors: "Field Of Study",
      winningtalent: "Company Winning Talent",
      losingtalent: "Company Losing Talent",
      recentGrowth: "Employees who joined within the selected time period.",
      recentAttrtion: "Employees who exited within the selected time period."
    };

    static VALID_CONTINENTS = [
      "asia", "africa", "north america", "oceania", "south america"
    ];

    static COMPANY_DETAILS = {
      COMPANY_COMPARE: "company-compare",
      COMPANY_DETAILS: "company-details"
    }

  static AI_SOURCING_APPLICABLE_FILTERS = new Set([
    GeneralConstants.FILTER_NAMES.OVERALL_MATCH,
    GeneralConstants.FILTER_NAMES.JOB_TITLE,
    GeneralConstants.FILTER_NAMES.LOCATION,
    GeneralConstants.FILTER_NAMES.SKILLS,
    GeneralConstants.FILTER_NAMES.COMPANY,
    GeneralConstants.FILTER_NAMES.COMPANY_SIZE,
    GeneralConstants.FILTER_NAMES.INDUSTRIES,
    GeneralConstants.FILTER_NAMES.YOE,
    GeneralConstants.FILTER_NAMES.SCHOOL,
    GeneralConstants.FILTER_NAMES.FIELD_OF_STUDY,
    GeneralConstants.FILTER_NAMES.EDUCATION,
  ]);

  static RESUME_SCREEN_APPLICABLE_FILTERS = new Set([
    GeneralConstants.FILTER_NAMES.KEYWORD_INPUT,
    GeneralConstants.FILTER_NAMES.OVERALL_MATCH
  ]);
}

